import { render, staticRenderFns } from "./FanCharacteristicsCreate.vue?vue&type=template&id=33cd053e&scoped=true&"
import script from "./FanCharacteristicsCreate.vue?vue&type=script&lang=js&"
export * from "./FanCharacteristicsCreate.vue?vue&type=script&lang=js&"
import style0 from "./FanCharacteristicsCreate.vue?vue&type=style&index=0&id=33cd053e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cd053e",
  null
  
)

export default component.exports